<app-session-expired></app-session-expired>
<router-outlet></router-outlet>
<app-toast-container></app-toast-container>
<!--<app-auth-main
  *ngIf="!canUserAccess"
  (canAccessEvent)="giveAccess($event)"
></app-auth-main>-->
<!--<ng-container *ngIf="canUserAccess">
  <div class="flex flex-row min-h-screen">
    <app-side-bar></app-side-bar>
    <div
      class="flex-1 flex flex-col bg-gray-50 pl-6 md:pl-10 lg:pl-16 pt-6 pr-4"
    >
      <app-header></app-header>
      <main class="flex-1 pt-8 sm:pt-10 xl:pt-12 2xl:pt-14">
        <router-outlet></router-outlet>
        <app-farmaco></app-farmaco>
      </main>
    </div>
  </div>
</ng-container>-->

<!--<ng-template *ngIf="canUserAccess">
<router-outlet></router-outlet> 
</ng-template> -->
